import Style from './style'
import MainHeader from 'widget/MainHeader'
import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useGetFranchiseTicketTransactionHistoryList from 'entity/franchise/useGetFranchiseTicketTransactionHistoryList'
import Search from 'widget/Search'
import TableLoading from 'shared/ui/TableLoading'
import SortableHeader from 'shared/ui/SortableHeader'
import Pagenation from 'widget/Pagenation'
import {convertClassificationAsName} from 'shared/constant/lookup/ticketType'

const MyFranchiseTicket = () => {
	const [transactionHistoryList, isLoading] =
		useGetFranchiseTicketTransactionHistoryList()

	const sizeList = [
		'short',
		'expand',
		'expand',
		'expand',
		'long',
		'medium',
		'long',
	]
	const tableHeadList = [
		{label: 'IDX', sortKey: 'idx'},
		{label: '매장명', sortKey: 'storeName'},
		{label: '매니저 이름', sortKey: 'managerName'},
		{label: '분류', sortKey: 'type'},
		{label: '매장 이용권 유형', sortKey: 'ticketTypeName'},
		{label: '번호', sortKey: 'count'},
		{label: '처리 날짜', sortKey: 'recordAt'},
	]

	return (
		<Style.Wrapper>
			<MainHeader>본사 지급 내역</MainHeader>

			<Search
				classificationFilter={true}
				voucherTypeFilter={true}
				hideSearchInput={true}
			/>

			<Style.AreaDiv>
				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									<SortableHeader sortKey={elem.sortKey}>
										{elem.label}
									</SortableHeader>
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{transactionHistoryList?.data?.items?.map((item, index) => {
							return (
								<TStyle.TableRow key={index} $odd={index % 2 === 1}>
									<TStyle.Data $size={sizeList[0]}>{item.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>
										{item.storeName}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>
										{item.managerName}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>
										{convertClassificationAsName[item.type]}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[4]}>
										{item.ticketTypeName}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[5]}>{item.count}</TStyle.Data>
									<TStyle.Data $size={sizeList[6]}>
										{timestampCalculator(item.recordAt)}
									</TStyle.Data>
								</TStyle.TableRow>
							)
						})}
					</TStyle.TableDiv>
				</TableLoading>
			</Style.AreaDiv>

			{transactionHistoryList?.data?.maxPage > 0 && (
				<Pagenation maxPage={transactionHistoryList?.data?.maxPage} />
			)}
		</Style.Wrapper>
	)
}

export default MyFranchiseTicket
